module.exports = __webpack_public_path__ + "img/ico_scotland.f434036a.png";